import React from "react";
import "./PremiumLoader.css";

const PremiumLoader = ({ size = "medium", color = "primary" }) => {
  const sizeClass =
    size === "small"
      ? "loader-sm"
      : size === "large"
        ? "loader-lg"
        : "";

  const colorClass =
    color === "secondary"
      ? "loader-secondary"
      : color === "white"
        ? "loader-white"
        : "";

  return (
    <div className="premium-loader-container">
      <div className={`premium-loader ${sizeClass} ${colorClass}`}></div>
    </div>
  );
};

export default PremiumLoader;